import { EducationItem } from '../../types';

export const educationData: EducationItem[] = [
  {
    id: 'unlp',
    degree: 'Computer Engineering',
    institution: 'Universidad Nacional de La Plata',
    period: '2012 — 2018',
    description: 'Focused on software engineering, embedded systems, and computer architecture.',
  },
];
